module.exports = __webpack_public_path__ + "img/LRC.b956ae4a.svg";